import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthUser } from '@classes/auth/auth-user';
import { NavLink } from '@classes/nav-link';
import { environment } from '@environments/environment';
import { faChartPie, faClipboardList, faSyncAlt, faTruck, faUser } from '@fortawesome/free-solid-svg-icons';
import { AppConfigService } from '@services/app-config/app-config.service';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { NavService } from '@services/nav/nav.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { OpendialogDeleteAllRecordsComponent } from '../opendialog-delete-all-records/opendialog-delete-all-records.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent extends SubscriptionBaseComponent implements OnInit, OnChanges {
  @Input() isAuth: boolean;
  @Output() sidenavClose = new EventEmitter<void>();

  faChartPie = faChartPie;
  faUser = faUser;
  faClipBoardList = faClipboardList;
  faTruck = faTruck;
  faSyncAlt = faSyncAlt;

  isAdmin = false;

  navItems = [{
    name: 'Dashboard',
    route: '/dashboard',
    icon: 'faChartPie'
  },
  {
    name: 'Gestion des utilisateurs',
    route: '/users',
    icon: 'faUser'

  },
  {
    name: 'Encodages',
    route: '/records',
    icon: 'faClipBoardList'
  },
  {
    name: 'Clicotte',
    route: '/clicotte',
    icon: 'faTruck'
  },

  {
    name: 'Supprimer les données',
    route: null,
    icon: 'faSyncAlt'
  },

  ];

  navLinks: NavLink[];

  appVersion: string;
  user: AuthUser;
  isMaintenance: boolean;
  isLocalTranslations: boolean;

  constructor(
    private configSrv: AppConfigService,
    private authSrv: AuthService,
    private navSrv: NavService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    this.initSub();
    this.appVersion = environment.version;
    this.isMaintenance = this.configSrv.isMaintenance;
    this.isLocalTranslations = environment.localTranslations;
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authSrv.getUser();
      this.navLinks = this.navSrv.getNavLinks();
    } else {
      this.user = null;
      this.navLinks = null;
    }
  }

  onCloseSidenav(): void {
    this.sidenavClose.emit();
  }

  openDialogDeleteRecords(): void {
    const dialogRef = this.dialog.open(OpendialogDeleteAllRecordsComponent, {
      width: '30%'
    });
  }



  private initSub(): void {
    this.subscription
      .add(
        this.dataService.isAdmin.asObservable().subscribe(isAdmin => {
          this.isAdmin = isAdmin;
          this.cdr.detectChanges();

        })
      );
  }
}
